import(/* webpackMode: "eager" */ "/vercel/path0/app/changelog/page.tsx");
